import Vue from 'vue';
import { trackPromoBannerView } from 'lib/tracking';
import { isTablet } from 'utils/general';
import {Autoplay, Pagination, A11y, Keyboard} from "swiper/modules";

export default (el) =>
  new Vue({
    components: {
      'vimeo-video-background': () =>
        import('../hero-slider/vimeo-video-background.vue'),
      'vue-swiper': () => import('../vue-swiper/vue-swiper.vue')
    },
    el,
    data() {
      return {
        isTablet: isTablet(),
        dotsPosition: 'right',
        swiper: null,
        swiperOptions: {
          slidesPerView: 1,
          a11y: true,
          keyboard: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
              return `<button class="${className}"></button>`;
            },
          },
          autoplay: el.dataset.autoplayDelay > 0 ? { delay: el.dataset.autoplayDelay } : false,
          modules: [Autoplay, Pagination, A11y, Keyboard]
        },
      };
    },
    mounted() {
      this.$el.dataset.enableTracking === 'true' &&
        trackPromoBannerView(this.$el);
    },
    methods: {
      onResize() {
        if (this.isTablet !== isTablet()) {
          const { carousel } = this.$refs;
          this.$nextTick(() => {
            if (carousel) carousel.swiper.update();
          });
        }
      }
    },
  });
